




















export default {
  name: 'search-box',
  mounted() {
    window.setTimeout(() => {
      this.agree()
    }, 60000)
  },
  computed: {
    tosLink() {
      return window.portalLink('legal/')
    },
    privacyLink() {
      return window.portalLink('privacy/')
    }
  },
  methods: {
    close() {
      this.agree()
    },
    agree() {
      this.$store.dispatch('persistent/acceptRules', new Date())
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/accept-terms.vue